import { buildPermission } from "portal/utils/auth";
import { FleetModulesTable } from "portal/components/FleetModulesTable";
import { FleetSubpath, getFleetPath, Path } from "portal/utils/routing";
import { LaserTable } from "portal/components/LaserTable";
import { Link, Navigate, useLocation, useRoutes } from "react-router-dom";
import { NoScroll } from "portal/components/Page";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { portalApi } from "portal/state/portalApi";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useQueryPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import React, { FunctionComponent } from "react";

const _FleetHardware: FunctionComponent = () => {
  const { data: hardware, isLoading } = useQueryPopups(
    portalApi.endpoints.getHardware.useQuery()
  );
  const { t } = useTranslation();

  const { pathname } = useLocation();

  // ### ROUTING
  const element = useRoutes([
    {
      path: Path.BASE,
      element: (
        <Navigate to={getFleetPath(FleetSubpath.HARDWARE_LASERS)} replace />
      ),
    },
    {
      path: `${FleetSubpath.HARDWARE_LASERS.replace(
        `${FleetSubpath.HARDWARE}`,
        ""
      )}`,
      element: (
        <NoScroll className="md:inset-0">
          <LaserTable lasers={hardware?.lasers} fleet loading={isLoading} />
        </NoScroll>
      ),
    },
    {
      path: `${FleetSubpath.HARDWARE_WEEDING_MODULES.replace(
        `${FleetSubpath.HARDWARE}`,
        ""
      )}`,
      element: (
        <NoScroll className="md:inset-0">
          <FleetModulesTable />
        </NoScroll>
      ),
    },
  ]);

  const sections: { path: string; name: string }[] = [
    {
      path: getFleetPath(FleetSubpath.HARDWARE_LASERS),
      name: t("models.lasers.laser_other"),
    },
    {
      path: getFleetPath(FleetSubpath.HARDWARE_WEEDING_MODULES),
      name: t("models.modules.module_other"),
    },
  ];

  return (
    <div className="w-full h-full flex flex-col">
      <ToggleButtonGroup
        color="standard"
        className="mb-8"
        exclusive
        value={pathname}
      >
        {sections.map(({ path, name }) => (
          <ToggleButton key={name} component={Link} to={path} value={path}>
            {name}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <div className="flex-grow relative">{element}</div>
    </div>
  );
};

export const FleetHardware = withAuthorizationRequired(
  // Fleet-wide hardware data requires `hardware:read:all` on the backend, so
  // this page is gated on that domain (matching the tab guard in Fleet.tsx).
  buildPermission(
    PermissionAction.read,
    PermissionResource.hardware,
    PermissionDomain.all
  ),
  _FleetHardware
);
